export default {
    computed: {
        ...amfx.map('session', 'userId'),
        ...amfx.map('recent', 'recentPages'),
        returnUrl() {
            return this.$route.query.returnUrl;
        }
    },
    methods: {
        async goToRecent() {
            await this.$store.dispatch('recent/load', this.userId);
            
            if(this.returnUrl) {
                window.location.href = this.returnUrl;
                return;
            }

            if(this.recentPages && this.recentPages.length) {
                this.$router.push(`/${this.recentPages[0].route}`);
            }
            else {
                this.$router.push('/');
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/framework/login-mixin.js